module.exports = __webpack_public_path__ + "01_mole.bb206ad2.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/papa/layer2/01_mole.png
// module id = kNpl
// module chunks = 0